import { INITIAL_STATE, setAccounts } from "../core"
import { RECEIVE_ACCOUNTS } from "../action_creators"

function accounts(state = INITIAL_STATE.accounts, action) {
    switch (action.type) {
        case RECEIVE_ACCOUNTS:
            return setAccounts(action.accounts)
        default:
            return state
    }
}

export default accounts


// WEBPACK FOOTER //
// ./src/redux/reducers/accounts_reducer.js